import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'

export const kaapiSecretsSelector = createSharedSelector(
  getDataSelector<DataKeys.KaapiSecrets>(DataKeys.KaapiSecrets),
  (kaapiSecrets) => {
    return kaapiSecrets
  },
)
